export default {
  "err.networkError": "接続に問題があります。しばらくしてからもう一度お試しください。",
  "err.houseIsOccupied": "既にスケジュールが存在しています。",
  "err.userNotFound": "ユーザーが見つかりません。",
  "err.userNoAccess": "アクセス権限がありません。",
  "err.operationDayNotFound": "指定した営業日のデータはありません。",
  "err.cannotRemovedMovieDuePastShowtime": "既に登録されている上映会があるため削除できません。",
  "err.uploadError": "アップロードできませんでした。",
  "err.500Error": "サーバーに接続できません。ネットワーク環境を確認して、再度実行してください。",
  "err.400Error": "リクエスト パラメータが正しくありません。しばらくしてからもう一度お試しください。",
  "err.uploadFileTooLarge": "アップロードするファイルは2MBを超えています。",
  "err.uploadFileTooLarge-1M": "アップロードするファイルは1MBを超えています。",
  "err.authInvalid": "認証トークンが有効ではありません。もう一度ログインしてください。",
  "err.usernamePwNotMatch": "ユーザー名またはパスワードが違います",
  "err.noPermission": "このページにアクセスする権限がありません。",
  "err.moviTicketNotFound": "ムビチケマスターの更新がありました。再度読み込みをして操作してください",
};